import React from 'react';
import { ResponsiveContainer, LineChart, Line, BarChart, Bar } from 'recharts';
import type { DiretoriaIndicatorMock } from '@/data/diretoriaMock';
import { diretoriaSparklineStroke } from '@/lib/diretoriaKpiTone';

/** Prévia compacta no cartão (ignora pizza e indicadores sem série). */
export const DiretoriaSparkline: React.FC<{ indicator: DiretoriaIndicatorMock }> = ({ indicator }) => {
  if (indicator.chartKind === 'pie' || indicator.chartKind === 'none' || !indicator.series?.length) {
    return <div className="h-10 w-full rounded-md bg-muted/40" aria-hidden />;
  }

  const pk = indicator.primaryKpiIndex ?? 0;
  const stroke = diretoriaSparklineStroke(indicator.kpis[pk]?.tone);
  const data = indicator.series.slice(-10);
  const h = 40;

  if (indicator.chartKind === 'bar') {
    const key = indicator.barSeriesKey ?? 'valor';
    return (
      <div className="w-full" style={{ height: h }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 2, right: 2, left: 0, bottom: 0 }}>
            <Bar dataKey={key} fill={stroke} radius={[2, 2, 0, 0]} isAnimationActive={false} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }

  return (
    <div className="w-full" style={{ height: h }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 4, right: 2, left: 0, bottom: 0 }}>
          <Line
            type="monotone"
            dataKey="valor"
            stroke={stroke}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
